import { IconProps } from '@drift-labs/icons';
import OrderbookVertical from 'src/components/Icons/OrderbookVertical';
import OrderbookHorizontal from 'src/components/Icons/OrderbookHorizontal';
import {
	ORDERBOOK_DISPLAY_TYPE,
	useOrderbookDisplayPreference,
} from './useOrderbookDisplayPreference';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import { cj } from 'src/utils/classNames';
import { ComponentType } from 'react';

const OrderbookStyleIconButton = ({
	icon,
	onClick,
	className,
}: {
	icon: ComponentType<IconProps>;
	onClick: () => void;
	className?: string;
}) => {
	return (
		<IconButton
			className={cj('rounded-xs p-xs', className)}
			size="sm"
			onClick={onClick}
			icon={icon}
		/>
	);
};

export const OrderbookStyleToggle = () => {
	const { orderbookDisplayType, setOrderbookDisplayType } =
		useOrderbookDisplayPreference();

	const selectedVertical =
		orderbookDisplayType === ORDERBOOK_DISPLAY_TYPE.VERTICAL;
	const selectedHorizontal =
		orderbookDisplayType === ORDERBOOK_DISPLAY_TYPE.HORIZONTAL;

	return (
		<div className="flex items-center gap-1">
			<OrderbookStyleIconButton
				className={selectedVertical ? undefined : '[&_rect]:fill-text-tertiary'}
				icon={OrderbookVertical}
				onClick={() => {
					setOrderbookDisplayType(ORDERBOOK_DISPLAY_TYPE.VERTICAL);
				}}
			/>
			<OrderbookStyleIconButton
				className={
					selectedHorizontal ? undefined : '[&_rect]:fill-text-tertiary'
				}
				icon={OrderbookHorizontal}
				onClick={() => {
					setOrderbookDisplayType(ORDERBOOK_DISPLAY_TYPE.HORIZONTAL);
				}}
			/>
		</div>
	);
};
